import { useEffect, useRef } from "react";
import { useAuth } from "../auth/AuthProvider";

interface ClarityWindow extends Window {
  clarity?: (method: string, ...args: unknown[]) => void;
}

const PUBLIC_LOADER_ID = "moneymap-public-analytics-consent";

function loadPublicAnalyticsConsent(): void {
  if (document.getElementById(PUBLIC_LOADER_ID)) return;

  const script = document.createElement("script");
  script.id = PUBLIC_LOADER_ID;
  script.async = true;
  script.src = "/analytics-consent.js";
  script.dataset.scope = "optional-public-analytics";
  document.head.appendChild(script);
}

function closePublicAnalyticsSession(): void {
  const clarityWindow = window as ClarityWindow;
  clarityWindow.clarity?.("consentv2", {
    ad_Storage: "denied",
    analytics_Storage: "denied"
  });
  clarityWindow.clarity?.("consent", false);
}

/**
 * Clarity is deliberately limited to the signed-out entry experience. Once a
 * session exists we reload the document so its recorder cannot survive into
 * the assessment, dashboard, billing, or result views of this SPA.
 */
export function PublicAnalytics() {
  const trackingStarted = useRef(false);
  const auth = useAuth();

  useEffect(() => {
    if (auth.loading) return;

    if (!auth.session) {
      loadPublicAnalyticsConsent();
      trackingStarted.current = Boolean(document.querySelector("[data-moneymap-public-analytics]"));
      return;
    }

    document.getElementById("moneymap-analytics-consent")?.remove();
    if (trackingStarted.current || document.querySelector("[data-moneymap-public-analytics]")) {
      closePublicAnalyticsSession();
      window.location.reload();
    }
  }, [auth.loading, auth.session]);

  return null;
}
